import { render, staticRenderFns } from "./OrderItemTile.vue?vue&type=template&id=124aeb76&"
import script from "./OrderItemTile.vue?vue&type=script&lang=js&"
export * from "./OrderItemTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports